module.exports = __webpack_public_path__ + "img/inspector-perfectionist-3.cf690879.svg";